import React from "react";
import { kakaoClipboard, KakaoShareButton } from "react-kakao-share";
import styled from "styled-components";

interface Props {
  isResult?: boolean;
  desc?: string;
}

const KakaoShareButtonT = ({ isResult, desc }: Props) => {
  const KAKAO_JAVASCRIPT_KEY = "b763a48b9aca8fba137b5da6db2f82df";
  const clipData = {
    title: "나락 퀴즈",
    description:
      desc ||
      "본 퀴즈를 누군가 앞에서 풀게되면 공격을 받고 지위나 직업을 박탈당할 수 있습니다. 즉, 나락에 가실 수 있습니다.",
    image: "https://stalwart-palmier-4f6d8a.netlify.app/logo512.png",
    APIKEY: KAKAO_JAVASCRIPT_KEY,
  };

  return (
    <Button onClick={() => kakaoClipboard(clipData)}>
      <KakaoShareButton size="30px" />
      {isResult ? <>카카오 결과 공유&nbsp;</> : <>카카오 공유&nbsp;</>}
    </Button>
  );
};

export default KakaoShareButtonT;

const Button = styled.div`
  cursor: pointer;
  background-color: rgb(254, 229, 0);
  color: black;
  font-family: "iceSotong-Rg";

  font-size: 25px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
`;
